import CreateVoucherForm from "@via/pages/account/admin/voucher-codes/components/create-voucher-form.tsx";
import EditVoucherDrawer from "@via/pages/account/admin/voucher-codes/components/edit-voucher-drawer.tsx";
import VoucherList from "@via/pages/account/admin/voucher-codes/components/voucher-list.tsx";
import {
  useDeleteVoucherCode,
  useGetVoucherCodes,
  useUpdateVoucherCode,
} from "@via/pages/account/admin/voucher-codes/voucher-codes.api.tsx";
import { VoucherCodeWithStatsRecord } from "common";
import { type JSX, useState } from "react";

const DEFAULT_PAGE_SIZE = 20;

export default function VoucherCodes(): JSX.Element {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);

  const { data, isLoading } = useGetVoucherCodes(page, pageSize);
  const { mutate: deleteVoucher, isPending: isDeleting } =
    useDeleteVoucherCode();
  const { mutate: updateVoucher, isPending: isRevoking } =
    useUpdateVoucherCode();

  const [isEditDrawerOpen, setIsEditDrawerOpen] = useState(false);
  const [voucherToEdit, setVoucherToEdit] =
    useState<VoucherCodeWithStatsRecord | null>(null);

  const handleEdit = (voucher: VoucherCodeWithStatsRecord) => {
    setVoucherToEdit(voucher);
    setIsEditDrawerOpen(true);
  };

  const handleCloseEditDrawer = () => {
    setIsEditDrawerOpen(false);
    setVoucherToEdit(null);
  };

  const handleRevoke = (id: number) => {
    updateVoucher({ id, isRevoked: true });
  };

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
    setPage(0);
  };

  return (
    <div className="space-y-5">
      <CreateVoucherForm />

      <hr className="border-gray-200" />

      <VoucherList
        vouchers={data?.data ?? []}
        total={data?.total ?? 0}
        isLoading={isLoading}
        isDeleting={isDeleting}
        isRevoking={isRevoking}
        page={page}
        pageSize={pageSize}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        onEdit={handleEdit}
        onRevoke={handleRevoke}
        onDelete={id => deleteVoucher({ id })}
      />

      <EditVoucherDrawer
        voucher={voucherToEdit}
        isOpen={isEditDrawerOpen}
        onClose={handleCloseEditDrawer}
      />
    </div>
  );
}
